import type { FC } from "react";

import type { FlowScreenConfig, FlowCustomComponentProps } from "@/shared/constants/flowTypes";

import {
  OngoingCostsChecklist,
  ALL_COST_KEYS,
  NONE_VALUE,
} from "../components/OngoingCostsChecklist";
import { AddOngoingCost } from "../components/AddOngoingCost";
import { createModuleComplete } from "@/pages/postloss/modules/components/ModuleComplete";

function createAddWrapper(costKey: string): FC<FlowCustomComponentProps> {
  const Wrapper: FC<FlowCustomComponentProps> = (props) => (
    <AddOngoingCost {...props} costKey={costKey} />
  );
  return Wrapper;
}

function createAddScreen(costKey: string): FlowScreenConfig {
  return {
    id: `add_ongoing_cost_${costKey}`,
    layout: "full",
    maxWidth: "4xl",
    hideButton: true,
    customComponent: createAddWrapper(costKey),
    shouldDisplay: ({ answers }) => {
      const selected = Array.isArray(answers["ongoing_costs_selected"])
        ? answers["ongoing_costs_selected"]
        : [];
      return (
        selected.includes(costKey) &&
        !selected.includes(NONE_VALUE) &&
        answers[`ongoing_cost_${costKey}_done`] !== "yes" &&
        answers[`ongoing_cost_${costKey}_done`] !== "skipped"
      );
    },
  };
}

export function createOngoingCostsScreens(): FlowScreenConfig[] {
  return [
    {
      id: "ongoing_costs_checklist",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: "Which of these are you or your family currently paying for?",
      subtitle: "These ongoing costs may be reimbursable from the estate. Select all that apply.",
      hideButton: true,
      customComponent: OngoingCostsChecklist,
    },
    ...ALL_COST_KEYS.map((key) => createAddScreen(key)),
    {
      id: "expenses_complete",
      layout: "full",
      textAlign: "center",
      hideButton: true,
      headerTitle: "",
      customComponent: createModuleComplete(),
    },
  ];
}
